import Modal from './_bootstrapModalExtensions';
import NotificationUtil from './_notificationUtil';
import * as Url from './Utils/UrlUtil';
import { NotifyUserAboutAjaxCallFailure } from './_takarnet';
import Interfaces from './_interfaces';

export function OnProcessEstateDeleteButtonClicked(event: JQuery.ClickEvent) {

    Modal.showConfirmationWindowAsync(
        'Biztosan törölni szeretné az ingatlant?',
        'Megerősítés',
        () => { deleteprocessEstate(); },
        () => { return false; },
        'Igen',
        'Nem')

    function deleteprocessEstate() {
        let $btn = $(event.target).parent();
        let processId: number = $btn.data('process-id') as number;
        let estateId: number = $btn.data('estate-id') as number;

        if (!processId || !estateId) {
            NotificationUtil.Error('Hiba történt az érintett ingatlan törlésekor. Kérjük, töltse újra az oldalt és próbálja meg újból!');
            return false;
        }

        let url: string = window.ETDR_RD.appConfig['UrlAction.DeleteEljarasIngatlanAdatai'];

        let grid: MVCxClientGridView = window['ProcessEstates'] as MVCxClientGridView;

        if (!url || !grid) {
            return;
        }

        $.ajax({
            method: 'POST',
            url: url,
            data: {
                'processId': processId,
                'estateId': estateId
            },
            headers: { Accept: 'application/json' }
        })
            .done((data: Interfaces.BaseJsonResponse) => {
                if (data.success) {
                    grid.Refresh();
                    NotificationUtil.Info('Az ingatlan törlése sikeres.');
                } else {
                    let errorText: string = 'Az ingatlan törlése sikertelen.'

                    if (data.errorText) {
                        errorText += ` ${data.errorText}`;
                    }

                    NotificationUtil.Error(errorText);
                }
            })
            .fail((jqXHR: JQueryXHR) => {
                NotifyUserAboutAjaxCallFailure(jqXHR);
            });
    }
}

function GetTitleDeedPdf(
    processEstateId: number,
    buttonId: string,
    requestDate: string,
    shouldAddNewLine: boolean) {
    let $button: JQuery<HTMLButtonElement> = $('#' + buttonId);
    let sendNewTakarnetRequest: boolean = $button.hasClass('history');

    if ($button) {
        disableButton();
    }

    $.ajax({
        method: 'POST',
        url: window.ETDR_RD.appConfig['UrlAction.GetTitleDeedPdf'],
        data: { processEstateId: processEstateId, sendNewTakarnetRequest: sendNewTakarnetRequest, requestDate: requestDate },
        headers: { Accept: 'application/json' }
    })
        .done((response: Interfaces.JsonResponseWithAttachment, status, xhr) => {

            if (!response.success) {
                generateErrorNotification(response);

                return;
            }

            openTitleDeedFile(response);

            addOtherOptionsButtonToGroup();

            if (shouldAddNewLine) {
                addNewLineToTable(response);
            }
        })
        .fail(() => {
            NotificationUtil.Error('Hiba történt a szerverrel történő kommunikáció során.');
        })
        .always(() => {
            if ($button) {
                enableButton();
            }
        });

    function addNewLineToTable(response: Interfaces.JsonResponseWithAttachment) {
        const $table = $('#title-deed-history-table');
        const newLine: string = `
<tr>
    <td>${response.uploadDate}</td>
    <td>${response.fileName}</td>
    <td>
        <button type="button" class="btn btn-secondary-oeny scale0_8 correct-scale-alignment-for-table title-deed-pdf-download-button" data-estate-id="${response.estateId}">Tulajdoni lap</button>
    </td>
</tr>`;

        if ($table) {
            $table.append(newLine);
        }
    }

    function generateErrorNotification(response: Interfaces.JsonResponseWithAttachment) {
        let errorText: string;

        if (response.message) {
            errorText = response.message;
        } else {
            errorText = 'Hiba történt a dokumentum lekérése során.';
        }

        NotificationUtil.Error(errorText);
    }

    function disableButton() {
        $button.prop('disabled', true);
        $button.prepend('<span id="button-spinner" class="spinner-border spinner-border-oeny mr-3" role="status" aria-hidden="true"></span>');
    }

    function enableButton() {
        $button.find('#button-spinner').remove();
        $button.prop('disabled', false);
    }

    function openTitleDeedFile(response: Interfaces.JsonResponseWithAttachment) {
        const byteCharacters: string = atob(response.content);
        const byteNumbers: number[] = getByteNumbers();
        const byteArray: Uint8Array = new Uint8Array(byteNumbers);
        const blob: Blob = new Blob([byteArray], { type: 'application/pdf; charset=ISO-8859-2' });

        const url: string = window.URL.createObjectURL(blob);

        let link: HTMLAnchorElement = document.createElement('a');
        link.href = url;
        link.download = response.fileName;
        link.click();

        function getByteNumbers(): number[] {
            var result = new Array(byteCharacters.length);

            for (let i = 0; i < byteCharacters.length; i++) {
                result[i] = byteCharacters.charCodeAt(i);
            }

            return result;
        }
    }

    function addOtherOptionsButtonToGroup() {
        const otherOptionsButton: string =
            `<button id="title-deed-history-modal-btn" type="button" class="btn btn-secondary-oeny"><span class="icon-ico-table-more d-block rotate-90"></span></button>`;

        if ($button.parent().children().length === 1 && !$button.data('ignore')) {
            $button.after(otherOptionsButton);
        }
    }
}

export function OnGetTitleDeedPdfButtonClicked(event: JQuery.TriggeredEvent) {
    const $button: JQuery<HTMLButtonElement> = $(event.currentTarget);
    const estateId: number = $button.data('estate-id');
    const buttonId: string = $button.attr('id');
    const requestDate: string = $button.parent().parent().children()[0].innerText
    const shouldAddNewLine: boolean = $button.data('should-add-new-line');

    GetTitleDeedPdf(estateId, buttonId, requestDate, shouldAddNewLine);
}

export function InitProcessEstateList() {
    $('.title-deed-pdf-download-button').on('click', (event: JQuery.ClickEvent) => {
        OnGetTitleDeedPdfButtonClicked(event);
    });
}

jQuery(() => {
    $(document).on('click', '.delete-subject-estate', (event: JQuery.ClickEvent) => {
        OnProcessEstateDeleteButtonClicked(event);
    });
    $(document).on('click', '.title-deed-pdf-download-button', (event: JQuery.ClickEvent) => {
        OnGetTitleDeedPdfButtonClicked(event);
    });
});
